import type { IconSvgObject } from './types';

const SquircleDashedIcon: IconSvgObject = [
  ["path", { d: "M2.49219 12C2.49219 4.02 4.01219 2.5 11.9922 2.5C19.9722 2.5 21.4922 4.02 21.4922 12C21.4922 19.98 19.9722 21.5 11.9922 21.5C4.01219 21.5 2.49219 19.98 2.49219 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SquircleDashedIcon;
